var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12H25C25 12 25.5 12 25.5 12.75C25.5 13.5 25 13.5 25 13.5H1C0.5 13.5 0.5 12.757 0.5 12.757C0.5 12.757 0.5 12 1 12Z",
    fill: "#1B75BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.44 18.7597L13.9532 15.5709L13.9474 15.5655C13.8437 15.4708 13.717 15.4013 13.5745 15.3682C13.2906 15.3012 12.9789 15.384 12.7645 15.6184L9.57038 19.1111C9.26152 19.4488 9.28545 19.985 9.62319 20.2939C9.96092 20.6027 10.4971 20.5788 10.806 20.2411L12.6366 18.2394L12.6897 23.1327C12.7101 23.5901 13.0412 23.8521 13.4986 23.8317C13.9559 23.8113 14.3083 23.5541 14.3083 23.1327L14.3083 18.1648L16.31 19.9954C16.6478 20.3042 17.184 20.2803 17.4928 19.9426C17.8017 19.6048 17.7778 19.0686 17.44 18.7597Z",
    fill: "#1B75BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61433 5.92586L12.9441 9.27843L12.9496 9.28407C13.0486 9.38372 13.1719 9.45922 13.3126 9.49909C13.5929 9.57963 13.9083 9.51188 14.1336 9.28807L17.4918 5.95278C17.8165 5.63026 17.8183 5.09352 17.4958 4.76879C17.1733 4.44406 16.6366 4.44223 16.3118 4.76475L14.3872 6.67626L14.3872 1.21975C14.3888 0.761947 14.2182 0.502681 13.5004 0.500229C13.0321 0.498629 12.7155 0.762156 12.7139 1.21996L12.7139 6.67052L10.8024 4.74592C10.4798 4.42119 9.9431 4.41936 9.61837 4.74187C9.29364 5.06439 9.29181 5.60113 9.61433 5.92586Z",
    fill: "#1B75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAll);
export default __webpack_public_path__ + "static/media/CollapseAll.9976236a3072725d7e259c13ca866450.svg";
export { ForwardRef as ReactComponent };